module.exports = __webpack_public_path__ + "img/1547195599.0155215e.jpg";